import { defineMessages } from 'react-intl'

export default defineMessages({
  typeEmployee: {
    id: 'Publishing.AudienceStep.Type.Employee',
    defaultMessage: 'Employee'
  },
  typeGroup: {
    id: 'Publishing.AudienceStep.Type.Group',
    defaultMessage: 'Group'
  },
  typeHeading: {
    id: 'Publishing.AudienceStep.Heading.Type',
    defaultMessage: 'Type'
  },
  valueHeading: {
    id: 'Publishing.AudienceStep.Heading.Value',
    defaultMessage: 'Name'
  },
  removeTitle: {
    id: 'Publishing.AudiencePreview.Remove',
    defaultMessage: 'Remove'
  },
  memberCountSubLabel: {
    id: 'Publishing.AudiencePreview.MemberCount',
    defaultMessage: '({count, number} {count, plural, one {Member} other {Members}})'
  }
})
